import Tween from "tween.ts";
import Animation from "../../../../../src/animation/Animation";


export default class DancePointsAnim extends Animation {
  private Anim = Animation.getInstance();
  private isStopped = false;
  
  constructor(targetRadians: number[], duration: number, onUpdate: (radians: number[]) => void, onComp: () => void, resolve: () => void) {
    super();

    this.rootEventBus.on(this.EnumRootEventBus.cancelledCircleAnim, () => this.isStopped = true);

    const radians = {
      radian1: 0,
      radian2: 0,
      radian3: 0
    };

    if(this.getIsCancelled()) {
      resolve();
      return 
    };

    new Tween.Tween({ ...radians })
      .to({
        radian1: targetRadians[0],
        radian2: targetRadians[1],
        radian3: targetRadians[2]
      }, duration)
      .easing(Tween.Easing.Linear.None)
      .onUpdate((r) => {
        if(this.isStopped) {
          this.isStopped = true;
          resolve();
          return
        }
        onUpdate([r.radian1, r.radian2, r.radian3]);
      }
    )
      .onComplete(() => onComp())
      .start();
  }
}